document.addEventListener("DOMContentLoaded", function () {
  initCardFeatures();
});

// Define both card features (image hover and swatches)

// This function will re-run after each pagination being
// invoked on loadMore function at ajaxinate.js
async function initCardFeatures(reload = false) {
  const allCards = document.querySelectorAll(".product__card--collection");
  const collectionProducts = await getAllProductsWithPagination();

  for (const card of allCards) {
    const form = card.querySelector("form");
    if (!form) {
      addHoverBehaviourForNonSwatchCard(card);
      continue;
    }
    const radios = form.querySelectorAll(".swatch-input__input");

    replaceParentDivForAnchor(card);

    const parentProductUrl = card
      .querySelector(".card__heading a")
      .href.split("/");
    const urlLastElement = parentProductUrl[parentProductUrl.length - 1];
    const parentProductHandle = urlLastElement.split("?")[0];

    const cardAnchors = card.querySelectorAll("a:not(.swatches__view-more-a)");
    await addHoverBehaviour(card, form, reload);
    await assignHandleToAnchors(parentProductHandle, cardAnchors, form);

    for (const radio of radios) {
      radio.addEventListener("change", async () => {
        await addHoverBehaviour(card, form, reload);
        await assignHandleToAnchors(parentProductHandle, cardAnchors, form);
      });

      // Reset the disabled label when a radio is clicked (since clicking the same radio wont fire the change event)
      radio.addEventListener("click", async () => {
        const disabledLabel = form.querySelector(".outline__disabled-temp");
        disabledLabel &&
          disabledLabel.classList.remove("outline__disabled-temp");
      });
    }
  }

  async function getProductData(selectedVariant) {
    let productData = JSON.parse(selectedVariant.getAttribute("data-product"));

    // If data-product is null, then fetch the product data from the server using its handle
    if (!productData) {
      const handle = selectedVariant.getAttribute("data-handle");
      productData = collectionProducts.find(
        (product) => product.handle === handle
      );
    }

    return productData;
  }

  // Assign the choosed variant product handle to the form action and all anchors
  async function assignHandleToAnchors(parentHandle, anchors, form) {
    const selectedVariant = form.querySelector(".swatch-input__input:checked");
    if (!selectedVariant) return;

    const productData = await getProductData(selectedVariant);

    const variantId = productData.variants[0].id;
    form.action = `/products/${parentHandle}?variant=${variantId}`;
    for (const anchor of anchors) {
      anchor.href = `/products/${parentHandle}?variant=${variantId}`;
    }
  }

  // Add the hover image feature to the product card of the selected variant
  // Reload parameter tells the function that we are reloading all elements trough paginate
  async function addHoverBehaviour(card, form, reload) {
    const radios = form.querySelectorAll(".swatch-input__input");
    const radiosArr = [...radios];

    // For the hover behaviour to work we need any selected radio, if none is checked, select the one that matches the current variant color
    const allRadiosUnchecked = radiosArr.every((radio) => !radio.checked);
    if (allRadiosUnchecked) {
      const currentVariantColor = card
        .getAttribute("data-color")
        .trim()
        .toLowerCase();
      for (const radio of radios) {
        if (radio.value.toLowerCase() === currentVariantColor) {
          radio.checked = true;

          // Disable the auto-outline styles for the selected radio at loading
          if (window.innerWidth > 768) {
            const label = radio.nextElementSibling;
            label.classList.add("outline__disabled-temp");
          }
          break;
        }
      }
    }

    const selectedVariant = form.querySelector(".swatch-input__input:checked");

    if (!selectedVariant) return;

    const productImage = card.querySelector("img");
    const productImageParentAnchor = card.querySelector("a.card__inner");
    const productData = await getProductData(selectedVariant);
    if (!(productData && productData.images.length > 1)) return;

    const [primaryImage, secondaryImage] = productData.images;
    const primaryImageSrc = formatImageSrc(primaryImage);
    const secondaryImageSrc = formatImageSrc(secondaryImage);

    productImage.src = primaryImageSrc;
    productImage.srcset = primaryImageSrc;

    // Update the image sources dynamically
    productImageParentAnchor.dataset.primaryImageSrc = primaryImageSrc;
    productImageParentAnchor.dataset.secondaryImageSrc = secondaryImageSrc;

    if (!productImageParentAnchor.dataset.hasEventListeners || reload) {
      productImageParentAnchor.addEventListener("mouseenter", () => {
        if (window.innerWidth < 768) return;

        const secondarySrc = productImageParentAnchor.dataset.secondaryImageSrc;

        assignImageSrc(productImage, secondarySrc);
      });

      productImageParentAnchor.addEventListener("mouseleave", () => {
        if (window.innerWidth < 768) return;

        const primarySrc = productImageParentAnchor.dataset.primaryImageSrc;

        assignImageSrc(productImage, primarySrc);
      });

      productImageParentAnchor.dataset.hasEventListeners = "true";
    }
  }

  async function addHoverBehaviourForNonSwatchCard(card) {
    const productId = Number(
      card.querySelector(".card__inner").id.split("-").at(-1)
    );
    const product = collectionProducts.find((p) => p.id === productId);
    const productImage = card.querySelector("img");

    if (!(product && product.images.length > 1)) return;

    const primaryImage = `${product.images[0].src}&width=400`;
    const secondaryImage = `${product.images[1].src}&width=400`;

    productImage.src = primaryImage;
    productImage.srcset = primaryImage;

    card.addEventListener("mouseenter", () => {
      productImage.src = secondaryImage;
      productImage.srcset = secondaryImage;
    });
    card.addEventListener("mouseleave", () => {
      productImage.src = primaryImage;
      productImage.srcset = primaryImage;
    });
  }
}

// Since products grouped by parents and products fetched from the API have different structures,
// we need to differentiate between them to assign the correct image path.
// This ensures that the correct image is displayed for each product variant,
// regardless of whether it is part of a parent group or fetched individually.
function formatImageSrc(image) {
  return image.src ? `${image.src}&width=400` : `https:${image}&width=300`;
}

// Assign the new image src to the image element
function assignImageSrc(imageElement, newSrc) {
  if (imageElement.src === newSrc || imageElement.srcset === newSrc) return;
  imageElement.src = newSrc;
  imageElement.srcset = newSrc;
}

// Transform image's parent container to anchor so it can redirect to product detail
function replaceParentDivForAnchor(card) {
  const cardInner = card.querySelector(".card__inner");
  if (!cardInner) return;

  // Create a new anchor element
  const newAnchor = document.createElement("a");

  // Copy all attributes and classes from card__inner to the new anchor
  Array.from(cardInner.attributes).forEach((attr) => {
    newAnchor.setAttribute(attr.name, attr.value);
  });
  newAnchor.className = cardInner.className;
  newAnchor.style = "cursor: pointer;";

  // Set the href attribute for the new anchor
  const fullUrl = card.querySelector(".card__heading a").href.split("/");
  newAnchor.href = `/products/${fullUrl[fullUrl.length - 1]}`;

  // Move all children from card__inner to the new anchor
  while (cardInner.firstChild) {
    newAnchor.appendChild(cardInner.firstChild);
  }

  // Replace card__inner with the new anchor
  cardInner.parentNode.replaceChild(newAnchor, cardInner);
}

// Fetch all products with pagination to use in casa an input does not have data-product attribute
async function getAllProductsWithPagination() {
  const baseUrl = `/products.json?limit=250`;
  let products = [];
  let nextPageUrl = baseUrl;

  try {
    while (nextPageUrl) {
      const response = await fetch(nextPageUrl);
      const data = await response.json();
      products = products.concat(data.products);
      const linkHeader = response.headers.get("Link");
      if (linkHeader) {
        const links = parseLinkHeader(linkHeader);
        nextPageUrl = links.next || null;
      } else {
        nextPageUrl = null;
      }
    }
  } catch (error) {
    console.error("Error fetching products with pagination", error);
  }
  return products;
}

function parseLinkHeader(header) {
  const linkHeadersArray = header.split(",").map((header) => header.trim());
  const links = {};

  linkHeadersArray.forEach((linkHeader) => {
    const match = linkHeader.match(/<([^>]+)>;\s*rel="([^"]+)"/);
    if (match) {
      const [, url, rel] = match;
      links[rel] = url;
    }
  });

  return links;
}

window.initCardFeatures = initCardFeatures;
